import React, { useMemo } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import {
    REVEAL_INITIAL,
    REVEAL_WHILE_IN_VIEW,
    REVEAL_VIEWPORT,
    buildRevealTransition,
} from '@/lib/motion';

// Static defaults reused when reduced-motion is requested.
const REDUCED_MOTION_STATE = {};

export const SectionReveal = ({ children, delay = 0, className = '' }) => {
    const reduced = useReducedMotion();
    // Memoise the transition so the same object identity is reused while the
    // `delay` prop doesn't change — important for framer-motion to avoid
    // re-triggering animations on incidental parent renders.
    const transition = useMemo(() => buildRevealTransition(delay), [delay]);
    return (
        <motion.div
            initial={reduced ? REDUCED_MOTION_STATE : REVEAL_INITIAL}
            whileInView={reduced ? REDUCED_MOTION_STATE : REVEAL_WHILE_IN_VIEW}
            viewport={REVEAL_VIEWPORT}
            transition={transition}
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default SectionReveal;
